module.exports = __webpack_public_path__ + "video.559ac347.png";